import { render, staticRenderFns } from "./doc-page.vue?vue&type=template&id=a6920a9c"
import script from "./doc-page.vue?vue&type=script&lang=js"
export * from "./doc-page.vue?vue&type=script&lang=js"
import style0 from "./doc-page.vue?vue&type=style&index=0&id=a6920a9c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports